// import { Button, Grid } from "@mui/material";
// import React from "react";
// import { useNavigate } from "react-router-dom";

// const DashboardTabs = () => {
//   const navigate = useNavigate();
//   return (
//     <Grid
//       container
//       spacing={1}
//       sx={{
//         background: "#F5F8FF",
//         margin: {
//           xs: "30px 0px 0px 0px", // padding for extra-small screens (e.g., mobile)
//           sm: "0px", // padding for small screens
//           md: "10px",
//         },

//         width: "100%",
//         borderRadius: "5px",
//         padding: {
//           xs: "0px", // padding for extra-small screens (e.g., mobile)
//           sm: "0px", // padding for small screens
//           md: "10px", // padding for medium screens and up
//         },
//         fontWeight: 600,
//         display: "flex",
//         flexWrap: "nowrap",
//       }}
//     >
//       <Grid item>
//         <Button
//           variant="contained"
//           size="medium"
//           sx={{
//             width: "100%",
//             margin: "5px",
//             fontWeight: "inherit",
//             "&:focus": { outline: "none" },
//           }}
//           onClick={() => {
//             navigate("/dashboard");
//           }}
//         >
//           Dashboard
//         </Button>
//       </Grid>
//       <Grid item>
//         <Button
//           variant="contained"
//           size="medium"
//           sx={{
//             width: "100%",
//             margin: "5px",
//             background: "#D2F0F4",
//             color: "#000000",
//             "&:focus": { outline: "none" },

//             "&:hover": {
//               color: "white",
//             },
//           }}
//           onClick={() => {
//             navigate("/call-dashboard");
//           }}
//         >
//           Call Dashboard
//         </Button>
//       </Grid>
//       <Grid item>
//         <Button
//           variant="contained"
//           size="medium"
//           sx={{
//             width: "100%",
//             margin: "5px",
//             background: "#D2F0F4",
//             color: "#000000",
//             "&:focus": { outline: "none" },

//             "&:hover": {
//               color: "white",
//             },
//           }}
//           onClick={() => {
//             navigate("/amcdashboard");
//           }}
//         >
//           AMC Dashboard
//         </Button>
//       </Grid>
//       <Grid item>
//         <Button
//           variant="contained"
//           size="medium"
//           sx={{
//             width: "100%",
//             margin: "5px",
//             background: "#D2F0F4",
//             color: "#000000",
//             "&:focus": { outline: "none" },

//             "&:hover": {
//               color: "white",
//             },
//           }}
//           onClick={() => {
//             navigate("/inventory-dashboard");
//           }}
//         >
//           Inventory Dashboard
//         </Button>
//       </Grid>
//       <Grid item>
//         <Button
//           variant="contained"
//           size="medium"
//           sx={{
//             width: "100%",
//             margin: "5px",
//             background: "#D2F0F4",
//             color: "#000000",
//             "&:focus": { outline: "none" },

//             "&:hover": {
//               color: "white",
//             },
//           }}
//           onClick={() => {
//             navigate("/service-dashboard");
//           }}
//         >
//           Service Dashboard
//         </Button>
//       </Grid>
//     </Grid>
//   );
// };

// export default DashboardTabs;


import { Button, Grid } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const DashboardTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Dashboard", path: "/dashboard" },
    // { label: "Call Dashboard", path: "/call-dashboard" },
    { label: "AMC Dashboard", path: "/amcdashboard" },
    { label: "Inventory Dashboard", path: "/inventory-dashboard" },
    { label: "Service Dashboard", path: "/service-dashboard" },
  ];

  return (
    <Grid
      container
      spacing={1}
      sx={{
        background: "#F5F8FF",
        margin: { xs: "30px 0px 0px 0px", sm: "0px", md: "10px" },
        width: "100%",
        borderRadius: "5px",
        padding: { xs: "0px", sm: "0px", md: "10px" },
        fontWeight: 600,
        display: "flex",
        flexWrap: "nowrap",
      }}
    >
      {tabs.map((tab) => (
        <Grid item key={tab.path}>
          <Button
            variant="contained"
            size="medium"
            sx={{
              width: "100%",
              margin: "5px",
              fontWeight: "inherit",
              background: location.pathname === tab.path ? "#33499F" : "#D2F0F4",
              color: location.pathname === tab.path ? "#fff" : "#000000",
              "&:focus": { outline: "none" },
              "&:hover": { color: "white", background: "#33499F" },
            }}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default DashboardTabs;
